const CTA_SELECTOR = 'a.cta:not(.ignore)';
const CONTAINER_ID = 'keep-in-view';

let attached = false;
let fixed = false;
let timeout;

/**
 * @returns {HTMLElement[]} the current page's call-to-action links.
 */
function ctaElements() {
  return [...document.querySelectorAll(CTA_SELECTOR)];
}

/**
 * @returns {HTMLElement} the reused floating-CTA container.
 */
function container() {
  let el = document.getElementById(CONTAINER_ID);

  if (!el) {
    el = document.createElement('div');
    el.id = CONTAINER_ID;
  }

  return el;
}

/**
 * @returns {boolean} whether the mobile menu is currently open.
 */
function mobileMenuOpen() {
  const toggle = document.getElementById('showMenu');

  return toggle ? toggle.checked : false;
}

/**
 * Clears the pinned CTA.
 *
 * @returns {void}
 */
function unfix() {
  fixed = false;

  const el = container();
  el.className = '';
  el.innerHTML = '';
}

/**
 * Pins a clone of the given CTA to the screen.
 *
 * @param {HTMLElement} cta
 * @returns {void}
 */
function fix(cta) {
  fixed = true;

  const el = container();
  el.innerHTML = '';
  el.className = 'animation-fadein';
  el.appendChild(cta.cloneNode(true));

  if (!el.parentNode)
    document.body.appendChild(el);
}

/**
 * @param {HTMLElement} el
 * @returns {boolean} whether the element is fully within the viewport.
 */
function inViewport(el) {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  const width = el.offsetWidth;
  const height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top >= window.pageYOffset &&
    left >= window.pageXOffset &&
    top + height <= window.pageYOffset + window.innerHeight &&
    left + width <= window.pageXOffset + window.innerWidth
  );
}

/**
 * Pins the first CTA once none are in view; re-queries the current page's CTAs
 * at scroll time so it works across Turbo navigations.
 *
 * @returns {void}
 */
function onScroll() {
  clearTimeout(timeout);

  unfix();
  // if the mobile menu is open, bail...
  if (mobileMenuOpen()) return;

  timeout = setTimeout(() => {
    const ctas = ctaElements();
    if (ctas.length === 0 || ctas[0].cloneNode === undefined) return;

    for (let i = ctas.length - 1; i >= 0; i--)
      if (inViewport(ctas[i])) return;

    if (!fixed)
      fix(ctas[0]);
  }, 100);
}

/**
 * Floating call-to-action: while scrolling, if no CTA is on screen it pins a
 * clone of the first one to the bottom of the viewport.
 *
 * The `scroll` and `#showMenu` listeners attach to `document` exactly once, and
 * the handler re-queries the current page's CTAs at event time, so re-running
 * `init()` on a Turbo navigation neither stacks listeners nor binds to a
 * discarded page's elements.
 */
export default {
  /**
   * Attaches the scroll/menu listeners once.
   *
   * @returns {void}
   */
  init() {
    if (attached) return;
    attached = true;

    document.addEventListener('scroll', onScroll, true);
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('#showMenu')) unfix();
    });
  }
};
